import { v4 as uuidV4 } from "uuid";
import { useMemo } from "react";
export var useUuid = function (dep) {
    return useMemo(function () { return uuidV4(); }, dep);
};
